import type { CreateTweetBodyJsonDataContent } from './createTweetBodyJsonDataContent';
import type { CreateTweetBodyJsonDataPoll } from './createTweetBodyJsonDataPoll';
import type { CreateTweetBodyJsonDataTags } from './createTweetBodyJsonDataTags';
import type { CreateTweetBodyJsonDataTweetType } from './createTweetBodyJsonDataTweetType';

export type CreateTweetBodyJsonData = {
  /** 트윗 내용 정보 */
  content: CreateTweetBodyJsonDataContent;
  /** 트윗에 포함될 투표 정보 (선택 사항) */
  poll?: CreateTweetBodyJsonDataPoll;
  /** 참조 트윗 ID (답글, 인용, 리트윗인 경우) */
  referencedTweetId?: string;
  /** 트윗 태그 정보 */
  tags?: CreateTweetBodyJsonDataTags;
  /** 트윗 유형 */
  tweetType?: CreateTweetBodyJsonDataTweetType;
};
